import React from "react"

const CheckBox = ({ field, form: { touched, errors }, ...props }) => (
  <div className="CheckBox">
    <input type="checkbox" {...field} {...props} id={field.name} />
    <label htmlFor={field.name}>
      <span className="box" />
      <span className="label-text">{props.placeholder}</span>
    </label>
    {touched[field.name] &&
      errors[field.name] && (
        <div className="error-message">{errors[field.name]}</div>
      )}
  </div>
)

export default CheckBox
